module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "loading"
    }
  }, [_c('span', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "list-container"
  }, [_c('h2', {
    attrs: {
      "id": "title"
    },
    on: {
      "click": _vm.openErrorDetails
    }
  }, [_vm._v(_vm._s(_vm.txtInit)), _c('span', {
    class: {
      pointSynchro1: !_vm.enErreur
    }
  }, [_vm._v(".")]), _c('span', {
    class: {
      pointSynchro2: !_vm.enErreur
    }
  }, [_vm._v(".")]), _c('span', {
    class: {
      pointSynchro3: !_vm.enErreur
    }
  }, [_vm._v(".")])]), _vm._v(" "), (_vm.enErreur) ? _c('div', {
    staticClass: "actions-erreur"
  }, [_c('a', {
    staticClass: "btn btn-full",
    attrs: {
      "href": "javascript: void 0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.reessayer($event)
      }
    }
  }, [_vm._v("Réessayer")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-wire",
    attrs: {
      "href": "javascript: void 0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.$router.push({
          name: 'home'
        })
      }
    }
  }, [_vm._v("Accueil")])]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "item-list"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('li', {
    attrs: {
      "id": "synchro_divers"
    }
  }, [_vm._v("\n                Autres téléchargements\n                "), _c('span', {
    staticClass: "numberDivers"
  }, [_vm._v(_vm._s(this.completedSteps) + "/" + _vm._s(this.totalSteps))]), _vm._v(" "), _c('span', {
    staticClass: "check-mark hide"
  }, [_vm._v("✔")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    attrs: {
      "id": "synchro_detenteur"
    }
  }, [_vm._v("\n                Téléchargement des détenteurs et installations\n                "), _c('span', {
    staticClass: "loaderSpin"
  }), _vm._v(" "), _c('span', {
    staticClass: "check-mark hide"
  }, [_vm._v("✔")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    attrs: {
      "id": "synchro_bouteille"
    }
  }, [_vm._v("\n                Téléchargement des bouteilles\n                "), _c('span', {
    staticClass: "loaderSpin"
  }), _vm._v(" "), _c('span', {
    staticClass: "check-mark hide"
  }, [_vm._v("✔")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    attrs: {
      "id": "synchro_profil"
    }
  }, [_vm._v("\n                Téléchargement du profil utilisateur\n                "), _c('span', {
    staticClass: "loaderSpin"
  }), _vm._v(" "), _c('span', {
    staticClass: "check-mark hide"
  }, [_vm._v("✔")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    attrs: {
      "id": "synchro_outils"
    }
  }, [_vm._v("\n                Téléchargement des outillages\n                "), _c('span', {
    staticClass: "loaderSpin"
  }), _vm._v(" "), _c('span', {
    staticClass: "check-mark hide"
  }, [_vm._v("✔")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    attrs: {
      "id": "synchro_distri"
    }
  }, [_vm._v("\n                Téléchargement des distributeurs\n                "), _c('span', {
    staticClass: "loaderSpin"
  }), _vm._v(" "), _c('span', {
    staticClass: "check-mark hide"
  }, [_vm._v("✔")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    attrs: {
      "id": "synchro_fluides"
    }
  }, [_vm._v("\n                Téléchargement des fluides\n                "), _c('span', {
    staticClass: "loaderSpin"
  }), _vm._v(" "), _c('span', {
    staticClass: "check-mark hide"
  }, [_vm._v("✔")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    attrs: {
      "id": "synchro_op_bouteille"
    }
  }, [_vm._v("\n                Téléchargement des opérations bouteille\n                "), _c('span', {
    staticClass: "loaderSpin"
  }), _vm._v(" "), _c('span', {
    staticClass: "check-mark hide"
  }, [_vm._v("✔")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    attrs: {
      "id": "synchro_otags"
    }
  }, [_vm._v("\n                Téléchargement des Otags\n                "), _c('span', {
    staticClass: "loaderSpin"
  }), _vm._v(" "), _c('span', {
    staticClass: "check-mark hide"
  }, [_vm._v("✔")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-abbdde56","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/InitLoading.vue
// module id = 781
// module chunks = 0